export default __webpack_public_path__ + "static/media/stocksnap.bc21c192.png";